import React from 'react';
import styled from 'styled-components';
import { Button, ButtonRow } from '../Common/StyledComponents';

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #ffffff;
  border-top: 1px solid #dee2e6;
  flex-shrink: 0;
`;

const WizardFooter = ({ onIntroClick, onSaveClick, onFinishClick, isSaving, onCloseClick }) => {
  return (
    <FooterWrapper>
      {
       // <Button variant="orange" onClick={onIntroClick} disabled={isSaving}>Intro</Button>
      }
      <ButtonRow>
      <Button variant="gray" onClick={onCloseClick} disabled={isSaving}>
          {'Close'}
        </Button>
        <Button variant="orange" onClick={onSaveClick} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
        <Button variant="orange" onClick={onFinishClick} disabled={isSaving}>{'Finish'}</Button>
      </ButtonRow>
    </FooterWrapper>
  );
};

export default WizardFooter;